import "./LegalNotice.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { Link } from "@/components/common/Link";
export default function LegalNoticePage() {
  return <div>
      <Header />

      <section className="bg-white py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6">
          {/* Titre principal */}
          <h1 className="text-2xl md:text-3xl font-serif font-semibold text-gray-800 mb-2">
            Mentions légales
          </h1>
          <p className="text-sm text-gray-400 mb-8">
            Dernière mise à jour : 28/03/2026
          </p>

          <p className="text-sm text-gray-600 leading-relaxed mb-10">
            Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004
            pour la confiance en l'économie numérique, voici les informations
            légales relatives au site www.effet-conseil.com.
          </p>

          {/* Édition du site */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Édition du site
          </h2>
          <div className="text-sm text-gray-600 leading-relaxed mb-8 space-y-1">
            <p>Dénomination sociale : EFFET CONSEIL</p>
            <p>Forme juridique : Société par actions simplifiée (SAS)</p>
            <p>Capital social : 5 000 €</p>
            <p>RCS : La Rochelle 838 575 355</p>
            <p>SIRET : 838 575 355 00029</p>
            <p>
              Code APE : 7022Z (Conseil pour les affaires et autres conseils de
              gestion)
            </p>
            <p>
              N° de déclaration d'activité : 75170340017 (Formation
              professionnelle)
            </p>
            <div className="mt-4">
              <p className="font-medium text-gray-700">Siège social :</p>
              <p>382 rue de Saint-Martin</p>
              <p>17580 Le Bois-Plage-en-Ré</p>
              <p>France</p>
            </div>
            <div className="mt-4">
              <p>Présidente : Christelle Charrier-Robelin</p>
              <p>Directrice de la publication : Christelle Charrier-Robelin</p>
            </div>
            <div className="mt-4">
              <p className="font-medium text-gray-700">Contact :</p>
              <p>christelle@effet-conseil.com</p>
              <p>06 40 86 81 29</p>
            </div>
          </div>

          {/* Hébergement */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Hébergement du site
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed mb-8">10Web</p>

          {/* Propriété intellectuelle */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Propriété intellectuelle
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed mb-8">
            L'ensemble du contenu du site (textes, images, logo, structure) est
            la propriété exclusive d'EFFET CONSEIL. Toute reproduction, même
            partielle, est interdite sans autorisation écrite préalable.
          </p>

          {/* Protection des données */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Protection des données personnelles
          </h2>
          <div className="text-sm text-gray-600 leading-relaxed mb-8 space-y-2">
            <p>
              EFFET CONSEIL traite vos données personnelles conformément au
              RGPD. Pour en savoir plus, consultez notre{" "}
              <Link to="/PrivacyPolicyPage" className="text-[#62751D] hover:underline">
                Politique de confidentialité
              </Link>
              .
            </p>
            <p>
              Responsable du traitement : Christelle Charrier-Robelin
            </p>
            <p>Contact : christelle@effet-conseil.com</p>
            <p>
              Vos droits : vous disposez d'un droit d'accès, de rectification,
              d'effacement, de limitation, de portabilité et d'opposition. Pour
              les exercer, contactez-nous par email.
            </p>
            <p>
              Vous pouvez également déposer une réclamation auprès de la CNIL :{" "}
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#62751D] hover:underline">
                www.cnil.fr
              </a>
            </p>
          </div>

          {/* Cookies */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Cookies
          </h2>
          <div className="text-sm text-gray-600 leading-relaxed mb-8 space-y-2">
            <p>
              Le site utilise des cookies pour améliorer votre navigation et
              réaliser des statistiques de visite. Vous pouvez les refuser via
              les paramètres de votre navigateur.
            </p>
            <p>
              Plus d'infos :{" "}
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#62751D] hover:underline">
                www.cnil.fr
              </a>
            </p>
          </div>

          {/* Droit applicable */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Droit applicable
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed mb-8">
            Les présentes mentions légales sont régies par le droit français. En
            cas de litige, les tribunaux français seront compétents.
          </p>
        </div>
      </section>

      <Footer />
    </div>;
}